<div class="p-3 d-flex flex-column justify-content-center middle-section">
  <img
    src="../../../assets/img/footer-trimble-maps.svg"
    alt="Routing &amp; Scheduling - Visualization - Navigation"
    class="p-4 img-fluid mx-auto text-center center-block"
    width="850"
  />
  <div class="p-4 d-flex flex-row mx-auto" style="width: 1200px">
    <div class="w-50 p-2 flex-fill">
      <p class="text-gray-5">
        <a
          href="https://maps.trimble.com"
          class="text-trimble-yellow hover-change"
          >Trimble MAPS</a
        >
        is dedicated to transforming journeys through innovative routing,<br />
        scheduling, visualization and navigation solutions. Rooted by map data
        and map-<br />centric technology specifically designed for commercial
        vehicles, its development<br />platform and trusted products are made
        for a broad range of industries, workforces<br />and fleets of all
        sizes.
      </p>
      <a
        href="https://www.trimble.com"
        class="btn btn-outline btn-rounded border text-gray-5 rounded-pill text-uppercase hover-change"
      >
        More about Trimble
      </a>
    </div>
    <div class="p-2 flex-fill">
      <ul class="list-unstyled">
        <li>
          <a
            href="https://maps.trimble.com/solutions/#appian"
            class="text-gray-5 hover-change"
            target="_blank"
            >Appian</a
          >
        </li>
        <li>
          <a
            href="https://copilotgps.com/"
            class="text-gray-5 hover-change"
            target="_blank"
            >CoPilot GPS</a
          >
        </li>
        <li>
          <a
            href="https://copilotpro.com/"
            class="text-gray-5 hover-change"
            target="_blank"
            >CoPilot Professional</a
          >
        </li>
        <li>
          <a
            href="https://copilottruck.com/"
            class="text-gray-5 hover-change"
            target="_blank"
            >CoPilot Truck</a
          >
        </li>
        <li>
          <a
            href="https://mileonapp.com/"
            class="text-gray-5 hover-change"
            target="_blank"
            >MileOn by PC<span class="pcmiler-asterisk">*</span>MILER</a
          >
        </li>
        <li>
          <a
            href="https://www.pcmiler.com/"
            class="text-gray-5 hover-change"
            target="_blank"
            >PC<span class="pcmiler-asterisk">*</span>MILER</a
          >
        </li>
        <li>
          <a
            href="https://maps.trimble.com/"
            class="text-gray-5 hover-change"
            target="_blank"
            >Trimble MAPS</a
          >
        </li>
        <li>
          <a
            href="https://developer.trimblemaps.com/"
            class="text-gray-5 hover-change"
            target="_blank"
            >Development Platform</a
          >
        </li>
      </ul>
    </div>
    <div class="p-2 flex-fill">
      <ul class="list-unstyled">
        <li>
          <a
            href="https://maps.trimble.com/legal/"
            class="text-gray-5 hover-change"
            target="_blank"
            >Legal</a
          >
        </li>
        <li>
          <a
            href="https://maps.trimble.com/privacy/"
            class="text-gray-5 hover-change"
            target="_blank"
            >Privacy</a
          >
        </li>
        <li>
          <a
            href="https://maps.trimble.com/cookies/"
            class="text-gray-5 hover-change"
            target="_blank"
            >Cookies</a
          >
        </li>
        <li>
          <a
            href="https://maps.trimble.com/contact/"
            class="text-gray-5 hover-change"
            target="_blank"
            >Contact</a
          >
        </li>
      </ul>
    </div>
    <div class="p-2 flex-fill social-media">
      <a href="https://www.linkedin.com/company/trimblemaps" target="_blank">
        <svg
          width="36"
          height="36"
          aria-hidden="true"
          role="img"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 448 512"
        >
          <path
            fill="#fff"
            d="M416 32H31.9C14.3 32 0 46.5.0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6.0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3.0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2.0 38.5 17.3 38.5 38.5.0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6.0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2.0 79.7 44.3 79.7 101.9V416z"
          ></path>
        </svg>
      </a>
      <a href="https://twitter.com/trimblemaps" target="_blank" rel="noopener">
        <svg
          width="36"
          height="36"
          aria-hidden="true"
          role="img"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 448 512"
        >
          <path
            fill="#fff"
            d="M4e2 32H48C21.5 32 0 53.5.0 80v352c0 26.5 21.5 48 48 48h352c26.5.0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-48.9 158.8c.2 2.8.2 5.7.2 8.5.0 86.7-66 186.6-186.6 186.6-37.2.0-71.7-10.8-100.7-29.4 5.3.6 10.4.8 15.8.8 30.7.0 58.9-10.4 81.4-28-28.8-.6-53-19.5-61.3-45.5 10.1 1.5 19.2 1.5 29.6-1.2-30-6.1-52.5-32.5-52.5-64.4v-.8c8.7 4.9 18.9 7.9 29.6 8.3a65.447 65.447.0 0 1-29.2-54.6c0-12.2 3.2-23.4 8.9-33.1 32.3 39.8 80.8 65.8 135.2 68.6-9.3-44.5 24-80.6 64-80.6 18.9.0 35.9 7.9 47.9 20.7 14.8-2.8 29-8.3 41.6-15.8-4.9 15.2-15.2 28-28.8 36.1 13.2-1.4 26-5.1 37.8-10.2-8.9 13.1-20.1 24.7-32.9 34z"
          ></path>
        </svg>
      </a>
      <a href="https://vimeo.com/trimblemaps" target="_blank">
        <svg
          width="36"
          height="36"
          aria-hidden="true"
          role="img"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 448 512"
        >
          <path
            fill="#fff"
            d="M403.2 32H44.8C20.1 32 0 52.1.0 76.8v358.4C0 459.9 20.1 480 44.8 480h358.4c24.7.0 44.8-20.1 44.8-44.8V76.8c0-24.7-20.1-44.8-44.8-44.8zM377 180.8c-1.4 31.5-23.4 74.7-66 129.4-44 57.2-81.3 85.8-111.7 85.8-18.9.0-34.8-17.4-47.9-52.3-25.5-93.3-36.4-148-57.4-148-2.4.0-10.9 5.1-25.4 15.2l-15.2-19.6c37.3-32.8 72.9-69.2 95.2-71.2 25.2-2.4 40.7 14.8 46.5 51.7 20.7 131.2 29.9 151 67.6 91.6 13.5-21.4 20.8-37.7 21.8-48.9 3.5-33.2-25.9-30.9-45.8-22.4 15.9-52.1 46.3-77.4 91.2-76 33.3.9 49 22.5 47.1 64.7z"
          ></path>
        </svg>
      </a>
    </div>
  </div>
</div>
